export const screenName = {
    'dashboard': 'Dashboard',
    'doc-master-list': 'DOC Master',
    'report': 'Report',
    'print': 'Print',
    'location': 'Location',
    'user_management': 'User',
    'dr-reports': 'Deviation Request',
};
export const uploadModalProps = {
    'buildup': 'FABRICATION',
    'test': 'BUILD UP & TEST',
    'pdi': 'PDI',
};